import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { LG, MD } from '@zendeskgarden/react-typography';
import { Dot, StyledChooseOurCompany, Reason, IntroText, Line, Image } from './ChooseOurCompany.styles.js';
import SVGLogo from 'components/AppHeader/components/SVGLogo'
import {  
  ShieldCheckLight
  } from 'svg/svgIcons';


const ChooseOurCompanyEquipment = (props) => {
  return (
    <StyledChooseOurCompany>
      {/*<div style={{marginBottom:'30px', position: 'relative'}}>
        <Line></Line>
        <IntroText>CHOOSE</IntroText>
        <Image><SVGLogo /></Image>
      </div>*/}

      <div style={{maxWidth: '650px', margin: '0px auto 0'}}>
        <Row>
          <Col className="shield" size="auto">
            <div style={{height: '60px'}}>
              <ShieldCheckLight width="80px" height="70px" />
            </div>
          </Col>
          <Col>
            <div>
              <MD scaled uppercase blue tag="h3" semibold>The Most Trusted Name In Medical Imaging</MD>
              <LG style={{maxWidth: '590px'}} paddingTopSm paddingBottomSm navy light tag="h3">Ensuring Artifact Free MRI Imaging through consultation to installation.</LG>
            </div>
          </Col>
        </Row>

          <Row>
            <Col className="shield" size="auto">
              <div style={{width: '80px'}}/>
            </Col>
            <Col>

              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">We break machines down to their component level. </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">We fix what needs fixed.  </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">We replace what needs replaced. </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">We provide the top most quality machines in the business </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">Leaning on the most knowledgeable, experienced people in the business.  </LG></Reason>
              <Reason><Dot></Dot><LG style={{maxWidth: '700px'}} slate tag="h3">Whether MRI, CT, PET, or ultrasound we take pride in providing the most dependable equipment and services in the market.  </LG></Reason>
            </Col>
          </Row>
      </div>
    </StyledChooseOurCompany>

  )
};

export default ChooseOurCompanyEquipment;

